import ResourceManager from "./ResourceManager";
import { Eye } from "lucide-react";

export default function AdminPages() {
  return (
    <ResourceManager
      title="Halaman"
      description="Kelola halaman kustom (About, Sejarah, Kebijakan Privasi, Syarat, dll). Setiap halaman dapat diakses di /p/{slug}."
      publicList="/admin/pages"
      adminBase="/admin/pages"
      extraRowActions={(item) => (
        <a
          href={`/p/${item.slug}${item.published ? "" : "?preview=1"}`}
          target="_blank"
          rel="noreferrer"
          title={item.published ? "Lihat halaman live" : "Preview draft"}
          data-testid={`page-preview-${item.id}`}
          className="h-8 w-8 rounded-lg border border-slate-200 hover:border-[var(--brand-orange)] hover:text-[var(--brand-orange)] flex items-center justify-center"
        >
          <Eye className="h-3.5 w-3.5" />
        </a>
      )}
      fields={[
        { name: "title", label: "Judul Halaman", required: true, placeholder: "contoh: Kebijakan Privasi" },
        { name: "slug", label: "Slug (URL)", required: true, placeholder: "kebijakan-privasi", help: "URL: /p/{slug}. Hanya huruf/angka/-/_" },
        { name: "subtitle", label: "Subjudul / Deskripsi Singkat", placeholder: "Muncul di bawah judul" },
        { name: "hero_image", label: "Hero Image", type: "image" },
        { name: "content", label: "Konten Halaman", type: "richtext", placeholder: "Tulis konten halaman di sini. Anda bisa menyisipkan gambar, heading, link, list, dll." },
        { name: "meta_description", label: "SEO Meta Description", placeholder: "Deskripsi untuk mesin pencari (opsional, 150-160 karakter)" },
        { name: "show_in_nav", label: "Tampilkan di menu navigasi", type: "boolean" },
        { name: "nav_label", label: "Label Menu (opsional)", placeholder: "Kosong = pakai judul" },
        { name: "nav_parent", label: "Parent Menu (opsional)", placeholder: "tentang / program / footer (untuk grouping)" },
        { name: "order", label: "Urutan", type: "number", default: 100 },
        { name: "published", label: "Terpublikasi (uncheck = simpan sebagai Draft)", type: "boolean", default: true },
      ]}
      listColumns={[
        { key: "order", label: "#" },
        { key: "title", label: "Judul" },
        { key: "slug", label: "URL", render: (r) => <code className="text-xs text-slate-500">/p/{r.slug}</code> },
        { key: "show_in_nav", label: "Di Menu", render: (r) => r.show_in_nav ? <span className="text-emerald-600 font-semibold text-xs">✓ Ya</span> : <span className="text-slate-400 text-xs">—</span> },
        { key: "published", label: "Status", render: (r) => r.published
          ? <span className="inline-flex items-center gap-1 text-emerald-600 font-semibold text-xs"><span className="h-1.5 w-1.5 rounded-full bg-emerald-500" /> Live</span>
          : <span className="inline-flex items-center gap-1 text-amber-600 font-semibold text-xs"><span className="h-1.5 w-1.5 rounded-full bg-amber-500" /> Draft</span> },
      ]}
      emptyText="Belum ada halaman kustom. Klik Tambah Baru untuk membuat halaman pertama."
    />
  );
}
